import { action, extendObservable } from 'mobx';
import orderBy from 'lodash/orderBy';
import FetchService from '../../../core/services/FetchService';
import FormService from '../../../core/services/FormService';
import ConfirmationDialogService from '../../../core/services/ConfirmationDialogService';
import NotificationService from '../../../core/services/NotificationService';

class PlacementTestListService {
  fetch = new FetchService();
  form = new FormService();

  constructor() {
    extendObservable(this, {
      placementTests: [],
      filter: '',
      rulerId: '',
    });
  }

  init = action((rulerId) => {
    this.placementTests = [];
    this.rulerId = rulerId;
    this.load();
  });

  load = action(() => {
    const filterValues = this.form.getValues();
    this.fetch
      .fetch({
        url: '/grammar-placement-test-levels',
        apiVersion: 'v3',
        query: {
          ...(this.form.getValue('grammar') && { grammar: this.form.getValue('grammar') }),
          ...(this.form.getValue('placementTestLevel') && {
            placementTestLevel: this.form.getValue('placementTestLevel'),
          }),
          ...(this.rulerId &&
            this.rulerId !== 'default' && {
              placementTestRuler: this.rulerId,
            }),
        },
      })
      .then(() => {
        if (this.fetch.data) {
          this.placementTests = orderBy(this.fetch.data, ['placementTestLevel.level', 'order'], ['asc', 'asc']);
        } else {
          this.placementTests = [];
        }
        this.form.setInitialValues({
          ...filterValues,
          placementTestRuler: filterValues?.placementTestRuler ? filterValues?.placementTestRuler : 'default',
        });
      });
  });

  handleRemove = action((grammarPlacementTest) => {
    ConfirmationDialogService.show(
      'Delete Grammar from Placement Tests',
      `You are about to delete the grammar "${grammarPlacementTest.grammar.name} - level ${grammarPlacementTest.placementTestLevel.level}", Do you want to continue ?`,
      () => {
        this.fetch
          .fetch({
            url: `/grammar-placement-test-levels/${grammarPlacementTest.id}`,
            method: 'delete',
            apiVersion: 'v3',
          })
          .then(() => {
            NotificationService.addNotification('Grammar deleted', 'success');
            this.load();
          });
      }
    );
  });
}

const placementTestListService = new PlacementTestListService();

export default placementTestListService;
